<p-toast />
<hr class="mt-0" />
<form [formGroup]="form" (submit)="onSave()" class="w-full">
  <div class="flex flex-column gap-2 mb-4">
    <div class="flex flex-column gap-2 mb-4">
    <label emRequiredMark for="name">{{ 'layout.configurations.nearShore.label.nameEn'| translate }}</label>
    <input
      id="name"
      formControlName="name"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.nearShore.placeholder.nameEn'| translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('name').invalid }" />
    <div *ngIf="isInvalid('name').invalid" class="text-red-600">{{ isInvalid('name').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('name') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label emRequiredMark for="nameEs">{{ 'layout.configurations.nearShore.label.nameEs'| translate }}</label>
    <input
      id="nameEs"
      formControlName="nameEs"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.nearShore.placeholder.nameEs'| translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('nameEs').invalid }" />
    <div *ngIf="isInvalid('nameEs').invalid" class="text-red-600">{{ isInvalid('nameEs').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('nameEs') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label emRequiredMark for="nameAr">{{ 'layout.configurations.nearShore.label.nameAr'| translate }}</label>
    <input
      id="nameAr"
      formControlName="nameAr"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.nearShore.placeholder.nameAr'| translate"
      class="w-full"
       dir="rtl"
      [ngClass]="{ 'p-invalid': isInvalid('nameAr').invalid }" />
    <div *ngIf="isInvalid('nameAr').invalid" class="text-red-600">{{ isInvalid('nameAr').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('nameAr') | translate }}</div>
  </div>
  </div>
  <hr />
  <div class="flex justify-content-end mb-4">
    <p-button type="submit" icon="pi pi-check"   [label]="  isEditMode ? ('layout.configurations.nearShore.editNearShore.save' | translate) : ('layout.configurations.nearShore.addNearShore.save' | translate)
      "
    ></p-button>
  </div>
</form>
